function setViewHeightVariable() {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
}

setViewHeightVariable();

window.addEventListener('resize', setViewHeightVariable);
